<template>
  <div class="app-container">
    <el-form :model="queryParams" ref="queryForm" :inline="true" label-width="68px">
      <el-form-item  prop="mchId">
        <el-input
          v-model="queryParams.mchId"
          placeholder="请输入商户mchId"
          clearable
          @keyup.enter.native="handleQuery"
        />
      </el-form-item>
      <el-form-item  prop="type">
        <el-select v-model="queryParams.type" placeholder="支付类型" clearable>
          <el-option label="微信" value="1"></el-option>
          <el-option label="支付宝" value="2"></el-option>
          <el-option label="云闪付" value="3"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" icon="el-icon-search"  @click="handleQuery">搜索</el-button>
        <el-button icon="el-icon-refresh"  @click="resetQuery">重置</el-button>
      </el-form-item>
    </el-form>

    <el-table v-loading="loading" border :data="payList" >
      <el-table-column type="index" width="55" align="center" />
      <el-table-column label="公司名称" align="center" prop="companyName" :show-overflow-tooltip="true" />
      <el-table-column label="支付公司" align="center" prop="name" :show-overflow-tooltip="true" />
      <el-table-column label="支付简称" align="center" prop="shortName" :show-overflow-tooltip="true"/>
      <el-table-column label="商户MchId" align="center" prop="mchId" :show-overflow-tooltip="true"/>
      <el-table-column label="支付类型" align="center" prop="type">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.type=='1'">微信</el-tag>
          <el-tag v-if="scope.row.type=='2'" type="danger">支付宝</el-tag>
          <el-tag v-if="scope.row.type=='3'" type="info">云闪付</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="平台appID" align="center" prop="appId" :show-overflow-tooltip="true" />
      <el-table-column label="终端号" align="center" prop="termNo" :show-overflow-tooltip="true" />
      <el-table-column label="请求地址" align="center" prop="serverUrl" :show-overflow-tooltip="true"/>

      <el-table-column label="投诉回调" align="center" prop="complaintNotifyStatus" :show-overflow-tooltip="true">

        <template slot-scope="scope">
          <el-tag v-if="scope.row.complaintNotifyStatus=='1'">已启用</el-tag>
          <el-tag v-if="scope.row.complaintNotifyStatus=='0'" type="danger">未启用</el-tag>
        </template>
      </el-table-column>
      <el-table-column label="投诉回调url" align="center" prop="complaintNotifyUrl" :show-overflow-tooltip="true"/>
      <el-table-column label="操作" align="center" width="220" fixed="right">
        <template slot-scope="scope">
          <el-button
            v-if="!!scope.row.complaintNotifyUrl"
            size="mini"
            type="primary" plain
            icon="el-icon-s-promotion"
            @click="handleComplaintNotify(scope.row)"
          >投诉回调</el-button>
          <el-button
            size="mini"
            type="primary" plain
            icon="el-icon-refresh"
            @click="handleRefreshComplaint(scope.row)"
          >投诉</el-button>
        </template>
      </el-table-column>
    </el-table>

  </div>
</template>

<script>
import { listPay , complaintNotify, refreshComplaint } from "@/api/api";


export default {
  name: "payConfig",
  data() {
    return {
      // 遮罩层
      loading: true,
      payList: [],
      // 弹出层标题
      // 查询参数
      queryParams: {
        postCode: undefined,
        postName: undefined,
        status: undefined
      },
    };
  },
  created() {
    this.getList();
  },
  methods: {
    /** 查询岗位列表 */
    getList() {
      this.loading = true;
      let params = {
        ... this.queryParams,
      }
      listPay(params).then(res => {
        this.payList = res.data.data;
        this.loading = false;
      });
    },
    /** 搜索按钮操作 */
    handleQuery() {
      this.getList();
    },
    /** 重置按钮操作 */
    resetQuery() {
      this.resetForm("queryForm");
      this.handleQuery();
    },
    /** 投诉回调推送 */
    handleComplaintNotify(row) {
      let params = {
        mchId: row.mchId,
      }
      complaintNotify(params).then(res => {
        this.getList();
        this.$message({
          message: "投诉回调推送成功",
          type: "success",
        });
      });
    },
    handleRefreshComplaint(row){
      let params = {
        mchId: row.mchId,
      }
      refreshComplaint(params).then(res => {
        this.$message({
          message: "投诉刷新成功",
          type: "success",
        });
      });
    }
  }
};
</script>
